'use client';

import { Skeleton } from '@/components/Skeleton';
import { useResponsive } from '@/modules/client';
import { BALANCE_HEIGHT } from './helpers';
import { ScBonusShopBalanceSkeleton } from './styled';

export const BonusShopBalanceSkeleton = () => {
  const { currentScreenType } = useResponsive();

  return (
    <ScBonusShopBalanceSkeleton>
      <Skeleton.Rect height={BALANCE_HEIGHT[currentScreenType]} rounded />
    </ScBonusShopBalanceSkeleton>
  );
};
